module.exports = __webpack_public_path__ + "static/billsby-customer-data-0e2704274ec385d7a181c8dba775062a.svg";